import { render, staticRenderFns } from "./impresionData4.vue?vue&type=template&id=dc10fc3e"
import script from "./impresionData4.vue?vue&type=script&lang=js"
export * from "./impresionData4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports